var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 107,
    viewBox: "0 0 103 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.176526 55.1639C0.176525 83.509 23.1548 106.487 51.5 106.487C79.8451 106.487 102.823 83.5091 102.823 55.1639V51.8361C102.823 23.491 79.8452 0.51267 51.5 0.512674C23.1548 0.512672 0.176528 23.491 0.176526 51.8361V55.1639ZM52.0446 46.5929L38.8944 33.4427L30.71 41.6271L43.8602 54.7774L30.4762 68.1614L38.1239 75.809L51.5079 62.425L64.6581 75.5753L72.8425 67.3908L59.6923 54.2406L73.1726 40.7603L65.5249 33.1127L52.0446 46.5929Z",
    fill: "#BCD696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.ca07a6c7ec5b3091cec0b4e0e08c96a0.svg";
export { ForwardRef as ReactComponent };